import { render, staticRenderFns } from "./marqaee.vue?vue&type=template&id=c9696612&scoped=true"
import script from "./marqaee.vue?vue&type=script&lang=js"
export * from "./marqaee.vue?vue&type=script&lang=js"
import style0 from "./marqaee.vue?vue&type=style&index=0&id=c9696612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9696612",
  null
  
)

export default component.exports